/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Theme } from '@nexigendigital/nxui'
import { OrderType, ProductServiceType, Weight } from 'models/enums'
import { CartItem } from 'models/shop'
import { useAppSelector } from 'store/hooks'

import CartConfigOption from 'containers/shop/cart/cartConfigOption'
import NewDomainContact from 'containers/shop/cart/newDomainContact'
import Options from 'containers/shop/cart/options'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    item: CartItem
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Configs({ item }: Props) {
    const { items, hosting } = useAppSelector((state) => state.shop)
    const pendingItem = items.find((pendingItem) => pendingItem.product_id === item.product_id && pendingItem.name === item.name)

    return (
        <StyledConfigs>
            <Config>
                {(item.config_options && pendingItem?.product_type === ProductServiceType.SharedHosting) &&
                    item.config_options.map((config_option) => (
                        <Options
                            key={config_option.config_id}
                            item={item}
                            configOption={config_option}
                            hosting={hosting}
                            id={item.product_id}
                        />
                    ))
                }
                {Object.keys(item).map((property: string, index) => (
                    <CartConfigOption key={index} item={item} option={property}/>)
                )}
                {(pendingItem?.product_type === 'domain' && !item.domain_contact_fields && item.order_type === OrderType.Register) &&
                    <NewDomainContact item={item}/>
                }
            </Config>
        </StyledConfigs>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const StyledConfigs = styled.div`
    display: grid;
    padding-left: 12px;
    ${Theme.Functions.setFont('Inter', Weight.Medium)};
`

const Config = styled.div`
    display: grid;
`
